import React, { useState } from "react";
import ModalComponent from "../../../ModalComponent";
import { Input } from "../../../Input";
import * as HTTPServices from "../../../../api/HTTPServices";
import classes from "./index.module.scss";

function Index({
  handleOpenFileUpload,
  handleCloseFileUpload,
  audienceId,
  visitToken,
  addMessageToList,
  attachType,
}) {
  const [description, setDescription] = useState("");
  const [file, setFile] = useState("");
  const [fileList, setFileList] = useState([]);

  const handleChange = (event) => {
    switch (event.target.name) {
      case "text":
        setDescription(event.target.value);
        break;
      case "file":
        const filesArray = Array.from(event.target.files);
        // this.setState({
        //   file: event.target.value,
        //   fileList: filesArray,
        // });
        setFileList(filesArray);
        setFile(event.target.value);
        break;
      default:
        break;
    }
  };

  const uploadFile = () => {
    // var Submit = document.getElementById("Submit");
    // Submit.disabled = true;
    // Submit.innerText = "loading...";

    var formData = new FormData();
    formData.append("message", description);
    formData.append("audience", audienceId);
    formData.append("room_token", visitToken);
    formData.append("length", fileList.length);
    if (attachType === "prescription") {
      formData.append("type", "prescriptionFile");
    } else {
      formData.append("type", "dossierFile");
    }
    for (let i = 0; i < fileList.length; i++) {
      if (file) {
        formData.append(`file${i}`, fileList[i]);
      } else {
        formData.append("file", "");
      }
    }

    // var Submit = document.getElementById("Submit");
    // Submit.disabled = true;

    const RequestService = HTTPServices.postMethod(
      "FileSend",
      formData,
      "true"
    );
    RequestService.then(function (response) {
      //   Submit.disabled = false;

      if (response) {
        addMessageToList(response.message[0]);
        setDescription("");
        setFile("");
        handleCloseFileUpload();
      } else {
        // Submit.disabled = false;
      }
    }).catch(function (error) {
      //   Submit.disabled = false;
    });
  };

  return (
    <ModalComponent
      open={handleOpenFileUpload}
      handleClose={handleCloseFileUpload}
      closeBtn={true}
      confirmBtn={true}
      handleOk={uploadFile}
      title="file upload dialoge"
    >
      <div className={classes.mainContainer}>
        <p>
          To submit a new documentary, please enter the information in the
          section below.
        </p>
        <div className={classes.contentDiv}>
          <textarea
            name="text"
            placeholder="descriptions"
            value={description}
            onChange={handleChange}
            className={classes.fullWidth}
          />
        </div>
        <label form="file">Uploaded file: image / video / audio message</label>
        <div className={classes.contentDiv}>
          <Input
            multiple
            id="file"
            name="file"
            type="file"
            onChange={handleChange}
            className={classes.fullWidth}
            style={{ border: "1px solid black" }}
          />
          <p>Acceptable files: png, jpeg, jpg, gif, ogg, mp3, mp4</p>
        </div>
      </div>
    </ModalComponent>
  );
}

export default Index;
